import { render } from "./VsUpload.vue?vue&type=template&id=792f518a"
import script from "./VsUpload.vue?vue&type=script&lang=js"
export * from "./VsUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__